/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Funnel_TrackingInputs */

const en_svchip_funnel_tracking = /** @type {(inputs: Svchip_Funnel_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funnel tracking`)
};

const ar_svchip_funnel_tracking = /** @type {(inputs: Svchip_Funnel_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتبع القمع`)
};

const bn_svchip_funnel_tracking = /** @type {(inputs: Svchip_Funnel_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফানেল ট্র্যাকিং`)
};

const de_svchip_funnel_tracking = /** @type {(inputs: Svchip_Funnel_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funnel-Tracking`)
};

const es_svchip_funnel_tracking = /** @type {(inputs: Svchip_Funnel_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento de embudos`)
};

const fr_svchip_funnel_tracking = /** @type {(inputs: Svchip_Funnel_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi d'entonnoirs`)
};

const pt_svchip_funnel_tracking = /** @type {(inputs: Svchip_Funnel_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreio de funis`)
};

const zh_svchip_funnel_tracking = /** @type {(inputs: Svchip_Funnel_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`漏斗追踪`)
};

const tr_svchip_funnel_tracking = /** @type {(inputs: Svchip_Funnel_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huni takibi`)
};

const ru_svchip_funnel_tracking = /** @type {(inputs: Svchip_Funnel_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Трекинг воронок`)
};

const pl_svchip_funnel_tracking = /** @type {(inputs: Svchip_Funnel_TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking lejków`)
};

/**
* | output |
* | --- |
* | "Funnel tracking" |
*
* @param {Svchip_Funnel_TrackingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_funnel_tracking = /** @type {((inputs?: Svchip_Funnel_TrackingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Funnel_TrackingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_funnel_tracking(inputs)
	if (locale === "bn") return bn_svchip_funnel_tracking(inputs)
	if (locale === "de") return de_svchip_funnel_tracking(inputs)
	if (locale === "es") return es_svchip_funnel_tracking(inputs)
	if (locale === "fr") return fr_svchip_funnel_tracking(inputs)
	if (locale === "pt") return pt_svchip_funnel_tracking(inputs)
	if (locale === "zh") return zh_svchip_funnel_tracking(inputs)
	if (locale === "tr") return tr_svchip_funnel_tracking(inputs)
	if (locale === "ru") return ru_svchip_funnel_tracking(inputs)
	if (locale === "pl") return pl_svchip_funnel_tracking(inputs)
	return en_svchip_funnel_tracking(inputs)
});